import React from "react";
import AccountDetails from "../components/AccountDetails";
const AccountsPage = () => {
  return <AccountDetails />;
};

export default AccountsPage;
